var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#acacac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-963 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 25,
    transform: "translate(963 489)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(931.496 489)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.1,8.882h-.6V6A.421.421,0,0,0,51.5,5.95a.477.477,0,0,0-.115-.315L46.6.166l0,0a.478.478,0,0,0-.1-.081L46.465.063a.511.511,0,0,0-.1-.04L46.343.014A.493.493,0,0,0,46.231,0H34.466a.975.975,0,0,0-.974.974V8.881h-.6A1.392,1.392,0,0,0,31.5,10.273V17.51A1.392,1.392,0,0,0,32.9,18.9h.6v4.954a.975.975,0,0,0,.974.974H50.532a.975.975,0,0,0,.974-.974V18.9h.6a1.392,1.392,0,0,0,1.392-1.392V10.273A1.392,1.392,0,0,0,52.1,8.882Zm-1.57,14.711H34.466V18.9H50.532v4.691Zm-11.71-7.229a2.2,2.2,0,0,0,.809-.107V14.736H38.509V13.452h2.708v3.83a8.141,8.141,0,0,1-2.427.41,4.052,4.052,0,0,1-2.956-.982,3.516,3.516,0,0,1-1.025-2.643c.01-2.416,1.769-3.8,4.153-3.8a5.008,5.008,0,0,1,2.017.356l-.345,1.316a4.031,4.031,0,0,0-1.694-.312,2.2,2.2,0,0,0-2.405,2.351A2.185,2.185,0,0,0,38.822,16.364ZM42.5,17.616v-7.27h1.65v7.27Zm7.336-4.261v1.337H47.226v2.923h-1.65v-7.27h4.445v1.348H47.226v1.661h2.611Zm.7-4.473H34.466V.974H45.744V5.956a.487.487,0,0,0,.487.487h4.3V8.882Z",
    transform: "translate(0 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/gif.7f6c44513f9980fe13a8525159d4e0b0.svg";
export { ForwardRef as ReactComponent };